//import { GameResult, PairResult, RoundResult } from './round-result.ts';

import {RoundResult} from './round-result.js';

//GameResult
// 0 : Tie
// 1 : BankerWin
// 2 : PlayerWin

function GameResultParser(char) {
    switch (char) {
        case 'R':
            return 1;//GameResult.BankerWin;
        case 'B':
            return 2;//GameResult.PlayerWin;
        case 'G':
            return 0;//GameResult.Tie;
        default:
            return undefined;
    }
}

//PairResult
// 0 : NoPair
// 1 : BankerPair
// 2 : PlayerPair
// 3 : AllPair
function PairResultParser(char) {
    switch (char) {
        case 'r':
            return 1;//PairResult.BankerPair;
        case 'b':
            return 2;//PairResult.PlayerPair;
        case 'n':
            return 0;//PairResult.NoPair;
        case 'a':
            return 3;//PairResult.AllPair;
        default:
            return undefined;
    }
}
function strToRoundResult(str, order) {
    const result = Number(str[1]);
    const winner = GameResultParser(str[0]);
    const pair = PairResultParser(str[2]);
    if (!Number.isInteger(result) || result < 0 || result > 9) {
        throw new Error(`[Invalid] Value not in range: ${str}`);
    }
    if (typeof winner === 'undefined') {
        throw new Error(`[Invalid] Winner not in range: ${str}`);
    }
    if (typeof pair === 'undefined') {
        throw new Error(`[Invalid] Pair not in range: ${str}`);
    }
    return new RoundResult(order, result, winner, pair, 0);
}

function fromRawData(results) {
    return results.map(strToRoundResult);
}

export {fromRawData};